import React from 'react';
import { Link } from 'react-router-dom';

import { RegisterLoc } from '../../loc/register';
import { loc } from '../../lib/loc';

import TopMenu from '../../interface/TopMenu';

export default function RegisterFormWrapper({ icon, backArrow, title, children }) {
    return (
        <div className="registration-legal-page pt-80 pb-150">
            <div className="registration-legal-page__container">
                <div className="registration-legal-page__wrap-elemets-page">
                    <div className="legal-form">
                        <TopMenu>
                            <Link to="/register">
                                <img src={backArrow} alt="кнопка назад" />
                            </Link>
                        </TopMenu>
                        <div className="legal-form__wrap-elements">
                            <div className="legal-form__wrap-icon">
                                <img className="legal-form__icon" src={icon} alt="" role="presentation" />
                            </div>
                            <div className="legal-form__title">{title}</div>
                            <div className="legal-form__text">{loc(RegisterLoc.opportunities)}</div>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
